<template>
    <div class="revshare">
		<div class="page-title">Реферальная программа</div>
        <div class="revshare__head" :style="{backgroundImage: isMob ? null : `url(${isTablet ? '/assets/boomx/images/revshare-banner.png' : '/assets/boomx/images/revshare-banner-pc.png'})`}">
			<div class="revshare__head-item">
				<div class="revshare__head-title">Приглашайте друзей и зарабатывайте!</div>
				<div class="revshare__head-text">Делитесь ссылкой и зарабатывайте <strong>{{ commission }}%</strong> от преимущества казино</div>
				<a class="revshare__head-link" target="_blank" href="https://protraffic.com/baza-znaniy/model-oplaty-revshare-revshara-kak-s-nej-ra-3713.html">Как работает RevShare?</a>
			</div>
			<div class="revshare__head-item">
				<div class="revshare__link" v-if="user !== null">
					<div class="revshare__link-inner">
						<div class="revshare__link-label">Ваша ссылка</div>
						<div class="revshare__link-value">
							{{ $root.$refhost +'/r/' + user.id }}
						</div>
					</div>
					<button class="revshare__link-btn btn" type="button" @click="copyLink">
						Копировать
						<svg class="btn__icon btn__icon--right">
							<use href="#svg-icon-copy"></use>
						</svg>
					</button>
				</div>
				<div class="revshare__note">
					Для увеличения <strong>% реферальной системы</strong> напишите менеджеру (поднимаем до 70%) <a class="revshare__note-link" target="_blank" :href="$root.$link.manager">{{ $root.$link.manager_username }}</a>
				</div>
			</div>
        </div>

		<div class="revshare__tabs">
			<div class="tabs" role="tablist">
				<div class="tabs__item" @click="currentTab = 'revshare'" :class="[currentTab === 'revshare' ? 'active' : '']">
					RevShare
				</div>
				<div class="tabs__item" @click="currentTab = 'promocodes'" :class="[currentTab === 'promocodes' ? 'active' : '']">
					Промокоды
				</div>
				<div class="tabs__item" @click="currentTab = 'referals'" :class="[currentTab === 'referals' ? 'active' : '']">
					Рефералы
				</div>
				<router-link class="tabs__item" v-if="user && (user.is_admin || user.can_transfer)" :to="{name: 'transfer'}">
					Перевод
				</router-link>
				<router-link class="tabs__item" v-if="user && (user.is_admin || user.max_loan)" :to="{name: 'loan'}">
					Займ
				</router-link>
			</div>
		</div>
		<div class="revshare__content">
			<div class="revshare__body" v-if="currentTab === 'revshare'">
				<template v-if="referrers && referrers.length">
					<div class="revshare__body-head">
						<div class="revshare__filter">
							<div class="revshare__filter-date">
								<VueDatePicker
									class="datepicker"
									v-model="date"
									placeholder="Период"
									dark
									range
									format="dd.MM.yyyy"
									auto-apply
									locale="ru"
									:enable-time-picker="false"
									@update:model-value="handlerSetPeriod"
								/>
							</div>
							<div class="revshare__filter-items">
								<button v-for="(item, index) in rangeOptions"
										:class="{'active': currentRange == index}"
										@click="getStatsForRange(index)"
										class="btn btn--sm revshare__filter-item">
									{{ item }}
								</button>
							</div>

						</div>
						<div class="revshare__update" v-if="captured_at">
							Информация обновлена в
							<span class="revshare__update-time">
								{{$root.moment(captured_at).format('HH:mm:ss')}}
							</span>
							{{ $root.moment(captured_at).format('DD/MM/YYYY') }}
						</div>
					</div>
					<div class="revshare__grid">
						<div class="revshare__grid-main">
							<div class="revshare__card" @click="takeProfit" :disabled="!can_take_profit"
							:class="{
								'success': can_take_profit,
								'danger': profit < 0
							}">
								<div class="revshare__card-label">Баланс RevShare</div>
								<div class="revshare__card-value">{{ $root.shortLargeNumber(profit) }}</div>
								<div class="revshare__card-row">
									<div class="revshare__card-item">
										<div class="revshare__card-subvalue">
<!--											<span class="revshare__card-range"-->
<!--												  :class="{ success: $root.shortLargeNumber(received_total_profit) }">-->
<!--												{{$root.shortLargeNumber(received_total_profit)}}-->
<!--											</span>-->
											{{ $root.shortLargeNumber(received_total_profit) }}</div>
										<div class="revshare__card-label">Выведено</div>
									</div>
									<div class="revshare__card-sep">/</div>
									<div class="revshare__card-item">
										<div class="revshare__card-subvalue">
<!--											<span class="revshare__card-range"-->
<!--												  :class="{ success: $root.shortLargeNumber(stats.total.profit) }">-->
<!--												{{$root.shortLargeNumber(stats.total.profit)}}-->
<!--											</span>-->
											{{$root.shortLargeNumber(stats.total.profit)}}</div>
										<div class="revshare__card-label">Прибыль</div>
									</div>
								</div>
								<div class="revshare__card-info" @click.stop="">
									<Informer size="lg">
										<strong>Формула расчета прибыли:</strong><br /><span style="color: #1CD6FF">Прибыль</span> (Депозиты – Выводы – Комиссии – Балансы)×<span style="color: #E80016">{{ commission }}%</span><br /><br />
										<strong>Расчёт комиссии:</strong> 10% с депозитов + 10% с разницы выигрышных и проигрышных ставок игроков
									</Informer>
								</div>
							</div>
						</div>
						<div class="revshare__grid-items">
							<div class="revshare__grid-item">
								<div class="revshare__card">
									<div class="revshare__card-label">Рефералов</div>
									<div class="revshare__card-subvalue">
									<span class="revshare__card-range"
										  :class="{ success: stats.range.referrers }">
										{{stats.range.referrers}}
									</span>
										{{ stats.total.referrers }}
									</div>
								</div>
							</div>
							<div class="revshare__grid-item">
								<div class="revshare__card">
									<div class="revshare__card-label">Комиссии</div>
									<div class="revshare__card-subvalue">
									<span class="revshare__card-range"
										  :class="{
											success: stats.range.commissions < 0,
											danger: stats.range.commissions > 0
										}"
									>
										{{ $root.shortLargeNumber(stats.range.commissions) }}
									</span>
										{{ $root.shortLargeNumber(stats.total.commissions) }}</div>
								</div>
							</div>
							<div class="revshare__grid-item">
								<div class="revshare__card">
									<div class="revshare__card-label">Балансы рефералов</div>
									<div class="revshare__card-subvalue">
										{{ $root.shortLargeNumber(stats.total.balance) }}
									</div>
									<div class="revshare__card-info">
										<Informer>
											Данный баланс это сумма всех балансов и незакрытых игр ваших рефералов. <br />
											С уменьшением или увеличением баланса ваших рефералов ваш доход может увеличиваться или уменьшаться соответственно.
										</Informer>
									</div>
								</div>
							</div>
							<div class="revshare__grid-item">
								<div class="revshare__card">
									<div class="revshare__card-label">Депозиты</div>
									<div class="revshare__card-subvalue">
									<span class="revshare__card-range"
										  :class="{
											success: stats.range.payments
										}">
										{{$root.shortLargeNumber(stats.range.payments)}}
									</span>
										{{ $root.shortLargeNumber(stats.total.payments) }}
									</div>
								</div>
							</div>
							<div class="revshare__grid-item">
								<div class="revshare__card">
									<div class="revshare__card-label">Выводы</div>
									<div class="revshare__card-subvalue">
									<span class="revshare__card-range"
										  :class="{
											success: stats.range.withdraws
										}">
										{{$root.shortLargeNumber(stats.range.withdraws)}}
									</span>
										{{ $root.shortLargeNumber(stats.total.withdraws) }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div v-else-if="!referrers?.length" class="empty-message">
					На текущий момент у Вас нету рефералов.
				</div>
			</div>
			<Partnership v-else-if="currentTab === 'promocodes'"/>
			<template v-else-if="currentTab === 'referals'">
				<div class="revshare__ref-table" v-if="referrers?.length">
					<div class="table">
						<table>
							<thead>
							<tr>
								<th scope="col"
									:class="{
									'sorting': sort.field != 'user_id',
									'sorting_asc': sort.field == 'user_id' && !sort.desc,
									'sorting_desc': sort.field == 'user_id' && sort.desc
								}"
									@click="doSort('user_id')">
									ID<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'user_id' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'username',
										'sorting_asc': sort.field == 'username' && !sort.desc,
										'sorting_desc': sort.field == 'username' && sort.desc
									}"
										@click="doSort('username')">
									Логин<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'username' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'register_date',
										'sorting_asc': sort.field == 'register_date' && !sort.desc,
										'sorting_desc': sort.field == 'register_date' && sort.desc
									}"
										@click="doSort('register_date')">
									Регистрация<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'register_date' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'payments',
										'sorting_asc': sort.field == 'payments' && !sort.desc,
										'sorting_desc': sort.field == 'payments' && sort.desc
									}"
										@click="doSort('payments')">
									Депозиты<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'payments' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'withdraws',
										'sorting_asc': sort.field == 'withdraws' && !sort.desc,
										'sorting_desc': sort.field == 'withdraws' && sort.desc
									}"
										@click="doSort('withdraws')">
									Выводы<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'withdraws' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'commissions',
										'sorting_asc': sort.field == 'commissions' && !sort.desc,
										'sorting_desc': sort.field == 'commissions' && sort.desc
									}"
										@click="doSort('commissions')">
									Комиссии<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'commissions' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'balance',
										'sorting_asc': sort.field == 'balance' && !sort.desc,
										'sorting_desc': sort.field == 'balance' && sort.desc
									}"
										@click="doSort('balance')">
									Баланс<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'balance' ?'sort':'chevron'}`"></use></svg>
								</th>
								<th scope="col"
										:class="{
										'sorting': sort.field != 'profit',
										'sorting_asc': sort.field == 'profit' && !sort.desc,
										'sorting_desc': sort.field == 'profit' && sort.desc
									}"
										@click="doSort('profit')">
									Доход<svg class="table__th-icon"><use :href="`#svg-icon-${sort.field != 'profit' ?'sort':'chevron'}`"></use></svg>
								</th>
							</tr>

							</thead>
							<tbody>
							<tr v-for="referrer in referrers" :key="referrer.user_id">
								<td class=" nowrap">{{ referrer.user_id }}</td>
								<td>{{ referrer.username }}</td>
								<td class="nowrap">{{ referrer.register_date }}</td>
								<td class="nowrap">
									{{ $root.currency(referrer.payments) }}
								</td>
								<td class="nowrap">
									{{ $root.currency(referrer.withdraws) }}
								</td>
								<td class="nowrap">
									{{ $root.currency(referrer.commissions) }}
								</td>
								<td class="nowrap">
									{{ $root.currency(referrer.balance) }}
								</td>
								<td class="nowrap">
									{{ $root.currency(referrer.profit) }}
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>

				<nav v-if="last_page > 1 && referrers?.length" class="revshare__pagination">
					<ul class="pagination">
						<template v-for="(link) in pagenav_links">
							<li class="pagination__item"
								v-if="link.active || link.url || link.label == '...'"
								:class="{
									'active': link.active,
									'disabled': ! link.url
								}">
								<button class="pagination__link" @click="goToPage(link.url)" v-html="link.label">										</button>
							</li>
						</template>
					</ul>
				</nav>
				<div v-else-if="!referrers?.length" class="empty-message">
					На текущий момент у Вас нету рефералов.
				</div>
				<div class="revshare__message">
					<div class=" revshare__update" v-if="captured_at">
						Информация обновлена в
						<span class="revshare__update-time">
								{{$root.moment(captured_at).format('HH:mm:ss')}}
							</span>
						{{ $root.moment(captured_at).format('DD/MM/YYYY') }}
					</div>
				</div>
			</template>
		</div>
		<div v-if="loan" class="revshare__message">
			<span>
					У Вас есть незакрытые кредиты на сумму: <strong>{{ loan }}</strong> ₽.
			</span>
			<div v-if="can_take_profit" class="small">
				При снятии RevShare, <strong>{{ profit >= loan ? loan : profit }}</strong> ₽ будет списано в качестве оплаты кредита.
			</div>
		</div>
	</div>
</template>

<script>
	import VueDatePicker from '@vuepic/vue-datepicker';
	import Partnership from "../partnership/Partnership.vue";
	import Informer from "../../components/blocks/Informer.vue";

	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";

    const DEFAULT_FIELD = 'profit';
    const DEFAULT_DIRECTION_DESC = true;

    export default {

		components: {
			Partnership,
			VueDatePicker,
			Informer
		},

		mixins: [
			breakpointsMixin
		],

		data() {
			return {
				showList: true,
				referrers: [],
				commission: 0,
				sort: {
					'field': DEFAULT_FIELD,
					'desc': DEFAULT_DIRECTION_DESC
				},
				page: 1,
				current_page: null,
				last_page: null,
				pagenav_links: [],
				stats: {
					range: {},
					total: {}
				},
				received_total_profit: 0,
				received_range_profit: 0,
				captured_at: null,
				can_take_profit: false,
				profit: 0,
				loan: null,
				isLoading: true,
				currentRange: 'today',
				rangeOptions: {
					yesterday: 'Вчера',
					today: 'Сегодня',
					week: 'Неделя',
					month: 'Месяц'
				},
				currentTab: 'revshare',
				date: null,
				start: null,
				end: null,
			}
        },
        mounted() {
            this.$root.isLoading = true;

            if (!this.$cookie.get('token')) {
                this.$root.isLoading = false;

                this.$toast.error('Требуется авторизация');

                return this.$router.go(-1);
            }

            this.getStats();
        },

		computed: {
			...mapState(useUserStore, ['user']),
		},

		methods: {
			getInfo() {
				this.$root.axios.post('/api/referrals/list', {
					'page': this.page,
					'field': this.sort.field,
					'direction': this.sort.desc ? 'desc' : 'asc'
				})
				.then(res => {
					this.referrers = res.data.referrers.data;
					this.revshare_commission_base = res.data.revshare_commission_base;
					this.current_page = res.data.referrers.current_page;
					this.last_page = res.data.referrers.last_page;
					this.pagenav_links = res.data.referrers.links;

					this.isLoading = false;
				});
			},
            getStats() {
                this.$root.axios.get('/api/referrals/info')
                    .then(res => {
                        this.commission = res.data.commission;
                        this.stats.total = res.data.total;
                        this.stats.range = res.data.range;
                        this.received_total_profit = res.data.received_total_profit;
                        this.received_range_profit = res.data.received_range_profit;
                        this.profit = res.data.profit;
                        this.captured_at = res.data.captured_at;
                        this.can_take_profit = res.data.can_take_profit;
                        this.loan = res.data.loan;
                        if(this.stats.total.referrers) {
                            this.getInfo();
                        }    

                        this.$root.isLoading = false;
                    });    
            },
			handlerSetPeriod(val) {
				let start = this.$root.moment(val[0]).format("YYYY-MM-DD")
				let end = this.$root.moment(val[1]).format("YYYY-MM-DD")
				this.getRangeStats(start, end);
				this.currentRange = null;
			},
			getRangeStats(start, end) {
				this.$root.axios.post('/api/referrals/stats', {
					'start': start,
					'end': end
				})
				.then(res => {
					this.stats.range = res.data.range;
					this.received_range_profit = res.data.received_range_profit;
				})
				.catch(error => {
					this.$toast.error(this.$root.graphql.axiosGetError(error));
				});
			},
			getStatsForRange(range) {
				if(this.currentRange == range) {
					return;
				}
				this.date = null;

				this.currentRange = range;
				this.start = this.end = '';
				let start,end;
				let currentDate  = new Date();

				switch (range) {
					case 'yesterday':
						start = this.$root.moment(currentDate).add(-1, 'days').format('YYYY-MM-DD');
						end = this.$root.moment(currentDate).add(-1, 'days').format('YYYY-MM-DD');
						break;
					case 'today':
						start = this.$root.moment(currentDate).format('YYYY-MM-DD');
						end = this.$root.moment(currentDate).format('YYYY-MM-DD');
						break;
					case 'week':
						start = this.$root.moment(currentDate).startOf('week').format('YYYY-MM-DD');
						end = this.$root.moment(currentDate).endOf('week').format('YYYY-MM-DD');
						break;
					case 'month':
						start = this.$root.moment(currentDate).startOf('month').format('YYYY-MM-DD');
						end = this.$root.moment(currentDate).endOf('month').format('YYYY-MM-DD');
						break;
				}

				this.getRangeStats(start, end);
			},
            refresh() {
                this.$root.axios.post('/api/referrals/revshare/refresh')
                    .then(res => {
                        const data = res.data;

                        this.$toast.success(data.message);

                        this.can_refresh = false;
                    })
                    .catch(error => {
                        this.$toast.error(this.$root.graphql.axiosGetError(error));
                    });
            },
            takeProfit() {
				if(!this.can_take_profit) {
					return;
				}

                this.$root.axios.post('/api/referrals/revshare/take')
                    .then(res => {
                        const data = res.data;

                        this.received_range_profit += this.profit;
                        this.received_total_profit += this.profit;
                        this.profit = 0;
                        this.user.balance = data.balance;
                        this.can_take_profit = false;
                    })
                    .catch(error => {
                        this.$toast.error(this.$root.graphql.axiosGetError(error));
                    });
            },
            doSort(column) {
                this.sort = {
                    'field': column,
                    'desc': !this.sort.desc
                };

                this.isLoading = true;

                this.getInfo();
            },
            goToPage(pageUrl) {
                let url = new URL(pageUrl);
                this.page = url.searchParams.get('page');

                this.isLoading = true;

                this.getInfo();
            },

			copyLink() {
				navigator.clipboard.writeText(this.$root.$refhost +'/r/' + this.user.id);
				this.$toast.success('Ссылка скопирована');
			}
        },
        sockets: {
            revshare_refresh: function() {
                this.getStats();
            }
        }
    }
</script>
